import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUpRight, FiPlus } from 'react-icons/fi';
import './voices-home-meaning.css';

const vocabulary = [
  ['focus', 'Open frame', 'Focus', 'Start by defining one useful workflow. The frame narrows attention to the job, not the technology.'],
  ['agent', 'Blue core', 'A scoped agent', 'One agent with a defined purpose, approved context and a person accountable for its work.'],
  ['layers', 'Three layers', 'A working system', 'Knowledge at the base, approved actions in the middle, and controls on top. They come together around the agent.'],
  ['connect', 'Linked rings', 'Integration', 'Existing systems and the agent workflow connect. The silver point marks the human approval or handoff boundary.'],
  ['care', 'Core, orbit and silver point', 'Continuous review', 'The core is the agent. The surrounding loop means evaluation and improvement; the silver point means human review.'],
  ['evidence', 'Opening photo and quote cards', 'Customer evidence', 'The widening window moves from an overview into a real customer story. One card gives one customer\u2019s complete words room to be read.'],
];
const captions = {
  focus: 'Open frame \u00b7 focus on one workflow.',
  agent: 'Blue core \u00b7 one scoped agent.',
  layers: 'Layers, bottom to top \u00b7 knowledge \u2192 actions \u2192 controls.',
  connect: 'Linked rings \u00b7 systems + workflow. Silver point \u00b7 human handoff.',
  care: 'Blue core \u00b7 agent. Orbit \u00b7 review cycle. Silver point \u00b7 person.',
};
const pathways = [
  ['AI implementation', 'From use case to tested workflow.', '/services/ai-implementation'],
  ['Agentic enterprise', 'Permissions, orchestration, and people.', '/services/agentic-enterprise-implementation'],
  ['OpenAI implementation', 'Model, knowledge, tools, and evaluation.', '/services/openai-implementation'],
  ['Claude implementation', 'Context-rich applications with clear controls.', '/services/claude-implementation'],
];

export function HomeFormMeaning({ meaning }) {
  return <p className="vh-form-meaning" data-meaning={meaning}>{captions[meaning]}</p>;
}

export function HomeMeaningGuide() {
  return <section className="vh-meaning-guide" aria-label="Our visual language">
    <details id="visual-language">
      <summary><span>One visual language. A clear meaning.</span><span className="vh-meaning-more">What the forms mean <FiPlus aria-hidden="true" /></span></summary>
      <div className="vh-meaning-inner">
        <p className="vh-meaning-intro">The zoom moves from a business need to a working system, then to customer evidence. These forms explain our approach; they are not diagrams of a particular deployment.</p>
        <dl>{vocabulary.map(([key, shape, title, definition]) => <div key={key} data-definition={key}><dt><span>{shape}</span>{title}</dt><dd>{definition}</dd></div>)}</dl>
        <p className="vh-meaning-finish">Blue carries the Antrazal identity. White and dark surfaces separate reading from exploration. Fine rims and seams are surface finish, not extra system components. The gold footer line is a closing accent{'\u2014'}not an award or certification. The final open frame returns to your next workflow.</p>
      </div>
    </details>
  </section>;
}

export function HomeExpertise() {
  return <section className="vh-pathways" aria-labelledby="pathways-title">
    <div className="vh-pathway-heading"><div><p className="v-label">The right implementation</p><h2 id="pathways-title">Start with the work.<br /><em>Choose the right approach.</em></h2></div><Link className="v-text-link" to="/implementation-guide">How to choose a partner <FiArrowUpRight aria-hidden="true" /></Link></div>
    <div className="vh-pathway-grid">{pathways.map(([title, description, to]) => <Link className="vh-pathway" to={to} key={to}><h3>{title}</h3><p>{description}</p><FiArrowUpRight aria-hidden="true" /></Link>)}</div>
  </section>;
}
